var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',{attrs:{"prepend":_vm.prefix,"size":"sm"}},[_c('b-input',{attrs:{"type":"number","id":_vm.id,"number":"","state":_vm.inputState},model:{value:(_vm.displayId),callback:function ($$v) {_vm.displayId=$$v},expression:"displayId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }